import React from 'react'
import { useJsApiLoader } from '@react-google-maps/api'
import FSPoleMap from './fs_polemap'

function FSGoogleMapLoader(props) {
    const { isLoaded, loadError } = useJsApiLoader({
        googleMapsApiKey: "AIzaSyB1rmwwP3SKl8a47tX4BYPIIwQZsuWLZRQ",
        libraries: ['places', 'drawing', 'geometry']
    })

    const renderMap = () => {
        return <FSPoleMap poleDataProps={props.poleDataProps} handleMapFullSize={props.handleMapFullSize} fullSizeMap={props.fullSizeMap} />
    }

    if (loadError) {
        return <div>Map cannot be loaded right now, sorry.</div>
    }

    return isLoaded ? renderMap() : null
}

export default React.memo(FSGoogleMapLoader)
